/**
 * Created by yuanjianxin on 2017/6/7.
 */
class HttpRequestTimeoutError extends Error{

}
const axios=require('axios');
export default class VueHttpUtil{

    constructor() {
        this.defheaders = {
            // 'credentials':'include',
            // 'Accept': 'application/json',
            // 'Content-Type': 'application/x-www-form-urlencoded',
            'X-Requested-With': 'XMLHttpRequest',
            'Content-Type':'application/x-www-form-urlencoded;charset=UTF-8',
            // 'Content-Type': 'application/json; charset=utf-8'
            // 'credentials':'include',
            'Accept': 'application/json',
            // 'Content-Type': 'application/json',
        }




    }

    get(url,data,callback,errorfun,headers,timeoutHander,timeoutValue,defaultValue,requestId){

        // let paras = data ? '?BODY='+encodeURIComponent(JSON.stringify(data)) : ''
        let paras = data ?'?'+Object.keys(data).map(k=>`${encodeURIComponent(k)}=${encodeURIComponent(data[k])}`).join('&') : '';

        this.sendRequest(url,'GET',paras,callback,errorfun,headers,timeoutHander,timeoutValue,defaultValue,requestId);


    }
    post(url,data,callback,errorfun,headers,timeoutHander,timeoutValue,defaultValue,requestId){
        this.sendRequest(url,'POST',data,callback,errorfun,headers,timeoutHander,timeoutValue,defaultValue,requestId);
    }




    async sendRequest(url,type,data,callback,errorfun,headers,timeoutHander,timeoutValue,defaultValue,requestId){

	    headers = {
		    'X-Requested-With': 'XMLHttpRequest',
		    'Content-Type':'application/x-www-form-urlencoded;charset=UTF-8',
		    'Accept': 'application/json',
	    };


        type.toUpperCase() ==='POST' && ( headers['Content-Type'] = 'application/json');
	    axios.defaults.withCredentials = true;


	    timeoutValue = timeoutValue || 3000;
        var timerId = 0;


        var timeoutFlag = false;
        timeoutHander && ( timerId = setTimeout( ()=>{
            timeoutFlag = true;
            timeoutHander && timeoutHander(new HttpRequestTimeoutError(url,type,data,defaultValue,timeoutValue))
        } , timeoutValue ) )
        let response=null;
        try{


	        response= type.toUpperCase() ==='POST' ?
                await axios.post(url,data,{headers,withCredentials:true,timeout:timeoutValue})
                : await axios.get(url+data,{headers,withCredentials:true});
	        response.requestId = requestId;
            // console.log('=====a,4')
	        // console.log('response=============',response)


            // response=type.toUpperCase() ==='POST' && await axios.post(url,data,{headers,withCredentials:true,timeout:timeoutValue}) || await axios(this.getHTTPData(url,type,data,headers,timeoutValue));

            timerId && clearTimeout(timerId);

        }catch(error){

            timerId && clearTimeout(timerId);
            errorfun && errorfun.apply(null,[error,timeoutFlag,timeoutValue]);
            return;
        }
        // console.log('===requestId 1===',response.requestId)
        !timeoutFlag && callback && callback.apply(null,[response]);
    }
}
